import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId
const getNamespace = () => store.state.app.namespace

export default {
  namespaced: true,
  state: {
    podSetResultInfo: {},
    pods: [],
    pod: {},
    fetchingPods: false,
    addingPod: false,
    removingPod: false,
  },
  mutations: {
    SET_PODS(state, data) {
      state.pods = data.result
    },
    SET_FETCHING_PODS(state, value) {
      state.fetchingPods = value
    },
    SET_ADDING_POD(state, value) {
      state.addingPod = value
    },
    SET_POD(state, value) {
      state.pod = value
    },
    SET_REMOVING_POD(state, value) {
      state.deletingPod = value
    },
  },
  actions: {
    fetchPods({ commit }) {
      commit('SET_FETCHING_PODS', true)
      return new Promise((resolve, reject) => {
        api('kyubi').get(`projects/${getProjectId()}/namespaces/${getNamespace()}/pods`)
          .then(response => {
            commit('SET_PODS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_PODS', false) })
      })
    },
    getPod({ commit }, pod) {
      commit('SET_FETCHING_PODS', true)
      return new Promise((resolve, reject) => {
        api('kyubi').get(`projects/${getProjectId()}/namespaces/${getNamespace()}/pods/${pod}`)
          .then(response => {
            commit('SET_POD', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_PODS', false) })
      })
    },
    addPod({ commit }, pod) {
      commit('SET_ADDING_POD', true)
      return new Promise((resolve, reject) => {
        api('kyubi').post(`projects/${getProjectId()}/namespaces/${getNamespace()}/pods`, pod)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_POD', false) })
      })
    },
    removePod({ commit }, pod) {
      commit('SET_REMOVING_POD', true)
      return new Promise((resolve, reject) => {
        api('kyubi').delete(`projects/${getProjectId()}/namespaces/${getNamespace()}/pods/${pod}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_POD', false) })
      })
    },
  },
}
